import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SimilarEvents = ({ events }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 lg:p-8 space-y-6">
      <h2 className="text-2xl font-bold text-[var(--color-foreground)]">Similar Events</h2>
      <div className="space-y-4">
        {events?.map((event) => (
          <div key={event?.id} className="bg-[var(--color-muted)] rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
            <div className="flex flex-col sm:flex-row">
              <div className="w-full sm:w-32 h-32 flex-shrink-0 overflow-hidden">
                <Image 
                  src={event?.image} 
                  alt={event?.imageAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 p-4 space-y-3">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-semibold text-[var(--color-foreground)] line-clamp-2">{event?.title}</h3>
                  <span className="px-2 py-1 bg-[var(--color-primary)]/10 text-[var(--color-primary)] rounded text-xs font-medium whitespace-nowrap">
                    {event?.category}
                  </span>
                </div>
                
                <div className="space-y-2 text-sm text-[var(--color-muted-foreground)]">
                  <div className="flex items-center gap-2">
                    <Icon name="Calendar" size={14} />
                    <span>{event?.date}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="MapPin" size={14} />
                    <span>{event?.location}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Users" size={14} />
                    <span>{event?.volunteers} volunteers needed</span>
                  </div>
                </div>

                <Button 
                  variant="outline" 
                  size="sm"
                  fullWidth
                  className="mt-2"
                >
                  View Details
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarEvents;